function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { BOS, HALIFAX, LLOYDS, MBNA, SCOTTISH_WIDOWS, WHITE_LABEL_DARK, WHITE_LABEL_LIGHT } from "../../constants";
import { useBrand } from "../BrandProvider";
import SvgIcon from "../SvgIcon";
var BosIcon = function BosIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 24V8.905h1.853v-2.28C5.853 2.931 8.903 0 12.5 0c3.596 0 6.647 2.932 6.647 6.624v2.281H21v14.986H4V24zm9.699-4.887v-2.715c.545-.434.872-.977.872-1.737a2.182 2.182 0 0 0-2.18-2.172c-1.199 0-2.18.977-2.18 2.172 0 .76.327 1.411.872 1.737v2.715H13.7zM16.75 8.905v-2.28c0-2.39-1.962-4.236-4.25-4.236-2.397 0-4.25 1.846-4.25 4.235v2.281h8.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
BosIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var HalifaxIcon = function HalifaxIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,11 L16,7 C16,4.85780461 14.3160315,3.10892112 12.1996403,3.00489531 L12,3 C9.85780461,3 8.10892112,4.68396847 8.00489531,6.80035966 L8,7 L8,11 L16,11 Z M18,13 L6,13 L6,21 L18,21 L18,13 Z M12,16 C12.5522847,16 13,16.4477153 13,17 C13,17.5522847 12.5522847,18 12,18 C11.4477153,18 11,17.5522847 11,17 C11,16.4477153 11.4477153,16 12,16 Z M6,7 C6,3.6862915 8.6862915,1 12,1 C15.2383969,1 17.8775718,3.56557489 17.9958615,6.77506174 L18,7 L18,11 L18.1492623,11.0054857 C19.1841222,11.0818349 20,11.9456382 20,13 L20,13 L20,21 C20,22.1045695 19.1045695,23 18,23 L18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,21 L4,13 C4,11.8954305 4.8954305,11 6,11 L6,11 L6,7 Z",
    fill: "currentColor"
  })));
};
HalifaxIcon.defaultProps = {
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var LloydsIcon = function LloydsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 24V8.905h1.853v-2.28C5.853 2.931 8.903 0 12.5 0c3.596 0 6.647 2.932 6.647 6.624v2.281H21v14.986H4V24zm9.699-4.887v-2.715c.545-.434.872-.977.872-1.737a2.182 2.182 0 0 0-2.18-2.172c-1.199 0-2.18.977-2.18 2.172 0 .76.327 1.411.872 1.737v2.715H13.7zM16.75 8.905v-2.28c0-2.39-1.962-4.236-4.25-4.236-2.397 0-4.25 1.846-4.25 4.235v2.281h8.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
};
LloydsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
var MaterialIcon = function MaterialIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.71429 24C4.24286 24 3.83929 23.8321 3.50357 23.4964C3.16786 23.1607 3 22.7571 3 22.2857V9.88571C3 9.41429 3.16786 9.01071 3.50357 8.675C3.83929 8.33929 4.24286 8.17143 4.71429 8.17143H6.71429V5.42857C6.71429 3.92667 7.24387 2.64643 8.30303 1.58786C9.36219 0.529286 10.6431 0 12.1459 0C13.6486 0 14.9286 0.529286 15.9857 1.58786C17.0429 2.64643 17.5714 3.92667 17.5714 5.42857V8.17143H19.5714C20.0429 8.17143 20.4464 8.33929 20.7821 8.675C21.1179 9.01071 21.2857 9.41429 21.2857 9.88571V22.2857C21.2857 22.7571 21.1179 23.1607 20.7821 23.4964C20.4464 23.8321 20.0429 24 19.5714 24H4.71429ZM4.71429 22.2857H19.5714V9.88571H4.71429V22.2857ZM12.1477 18.2857C12.754 18.2857 13.2714 18.0759 13.7 17.6563C14.1286 17.2366 14.3429 16.7322 14.3429 16.1429C14.3429 15.5714 14.127 15.0524 13.6952 14.5857C13.2634 14.119 12.7444 13.8857 12.1381 13.8857C11.5317 13.8857 11.0143 14.119 10.5857 14.5857C10.1571 15.0524 9.94286 15.5762 9.94286 16.1571C9.94286 16.7381 10.1587 17.2381 10.5905 17.6571C11.0223 18.0762 11.5413 18.2857 12.1477 18.2857ZM8.42857 8.17143H15.8571V5.42857C15.8571 4.39682 15.4964 3.51984 14.7748 2.79763C14.0532 2.0754 13.177 1.71429 12.1462 1.71429C11.1154 1.71429 10.2381 2.0754 9.51429 2.79763C8.79048 3.51984 8.42857 4.39682 8.42857 5.42857V8.17143Z",
    fill: "currentColor"
  }));
};
MaterialIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var MbnaIcon = function MbnaIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.85714286,12 C2.85714286,10.908783 3.62005179,10.5 4.3535723,10.5 C4.99320389,10.5 4.3535723,10.5 5.10714286,10.5 C5.10714286,9.186369 5.10714286,7.26535034 5.10714286,6.375 C5.10714286,3.00892639 8.48461478,2.13162821e-14 11.8571429,2.13162821e-14 C15.2466997,2.13162821e-14 18.6071429,3.00585938 18.6071429,6.375 C18.6071429,7.40339173 18.6071429,9.20343412 18.6071429,10.5 C19.2641482,10.5 18.6071429,10.5 19.3439593,10.5 C20.1382708,10.5 20.8571429,11.2974243 20.8571429,12 C20.8571429,12.4390233 20.8571429,15.6179174 20.8571429,22.4820557 C20.8571429,23.3117065 20.1347918,24 19.3571429,24 C18.8643555,24 10.1799883,24 4.3535723,24 C3.61053031,24 2.85714286,23.287262 2.85714286,22.4820557 C2.85714286,21.6768494 2.85714286,13.091217 2.85714286,12 Z M7.35714286,6.75 C7.35714286,8.12988281 7.35714286,9.37988281 7.35714286,10.5 L16.3571429,10.5 C16.3571429,9.42431641 16.3571429,8.17431641 16.3571429,6.75 C16.3571429,4.52627563 14.1084246,2.25 11.8571429,2.25 C9.60586112,2.25 7.35714286,4.16885376 7.35714286,6.75 Z M10.3571429,15.75 C10.3571429,16.2704773 10.4614672,16.5437164 10.7321429,16.875 C11.1071429,17.25 11.1071429,18 11.1071429,18.375 C11.1071429,18.8764343 11.1071429,19.1138306 11.1071429,19.5 C11.1071429,19.8861694 11.4778399,20.25 11.8571429,20.25 C12.2364458,20.25 12.6071429,19.8886871 12.6071429,19.5 C12.6071429,19.1113129 12.6071429,18.9342957 12.6071429,18.375 C12.6071429,17.8157043 12.6071429,17.25 12.9821429,16.875 C13.2720217,16.5541992 13.3571429,16.3052673 13.3571429,15.75 C13.3571429,15.0097567 12.6121325,14.25 11.8571429,14.25 C11.1021532,14.25 10.3571429,15.013986 10.3571429,15.75 Z"
  }));
};
MbnaIcon.defaultProps = {
  fill: "currentColor",
  fillRule: "evenodd",
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};
var ScottishWidowsIcon = function ScottishWidowsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".prefix__st0", "{", "fill:currentColor", "}", ".prefix__st1", "{", "fill-rule:evenodd;clip-rule:evenodd;fill:currentColor", "}"), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st0",
    d: "M14,15.5c0-1.4-1.1-2.5-2.5-2.5C10.1,13,9,14.1,9,15.5c0,1,0.6,1.9,1.5,2.3V19c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.2 C13.4,17.4,14,16.5,14,15.5z M11.5,14.6c0.5,0,0.9,0.4,0.9,0.9c0,0.4-0.3,0.8-0.7,0.9c0,0-0.1,0-0.3,0h0l0,0l-0.1,0 c-0.4-0.1-0.7-0.5-0.7-0.9C10.6,15,11,14.6,11.5,14.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "prefix__st1",
    d: "M17.4,8H16V5.4C16,2.9,14,1,11.5,1C9,1,7,2.9,7,5.3V8H5.6C4.2,8,3,9.1,3,10.5v11C3,22.9,4.2,24,5.6,24h11.8 c1.4,0,2.6-1.1,2.6-2.5v-11C20,9.1,18.8,8,17.4,8z M9,5.3C9,4.1,10.1,3,11.5,3C12.9,3,14,4.1,14,5.4V8H9V5.3z M18,21.5 c0,0.3-0.2,0.5-0.6,0.5H5.6C5.3,22,5,21.8,5,21.5v-11C5,10.2,5.3,10,5.6,10h11.8c0.3,0,0.6,0.2,0.6,0.5V21.5z"
  }));
};
ScottishWidowsIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useTheme } from 'styled-components';
export default function (_ref) {
  var _theme$assets, _theme$assets$icons;
  var rest = _extends({}, _ref);
  var _ref2 = useBrand() || {},
    _ref2$brand = _ref2.brand,
    brand = _ref2$brand === void 0 ? LLOYDS : _ref2$brand;
  var theme = useTheme() || {};
  var svg;
  if ((_theme$assets = theme.assets) !== null && _theme$assets !== void 0 && (_theme$assets$icons = _theme$assets.icons) !== null && _theme$assets$icons !== void 0 && _theme$assets$icons.padlock) {
    var _theme$assets2, _theme$assets2$icons;
    svg = (_theme$assets2 = theme.assets) === null || _theme$assets2 === void 0 ? void 0 : (_theme$assets2$icons = _theme$assets2.icons) === null || _theme$assets2$icons === void 0 ? void 0 : _theme$assets2$icons.padlock;
  } else {
    switch (brand) {
      case BOS:
        svg = BosIcon;
        break;
      case HALIFAX:
        svg = HalifaxIcon;
        break;
      case LLOYDS:
        svg = LloydsIcon;
        break;
      case MBNA:
        svg = MbnaIcon;
        break;
      case SCOTTISH_WIDOWS:
        svg = ScottishWidowsIcon;
        break;
      case WHITE_LABEL_DARK:
      case WHITE_LABEL_LIGHT:
        svg = MaterialIcon;
        break;
      default:
        // eslint-disable-next-line no-console
        console.warn("Icon is not available in brand \"".concat(brand, "\"."));
        svg = function svg() {
          return null;
        };
    }
  }
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    svg: svg
  }, rest));
}